export default {
	name: 'available-languages'
};



// WEBPACK FOOTER //
// ./sources/components/available-languages/index.js